





































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ProductMaterialForm from '@/components/products/material-form.vue';

@Component({
  components: { PermissionAuth, ProductMaterialForm },
})
export default class ProductMaterial extends BaseComponent {
  @Prop()
  public data: any[];
  @Prop({
    default: false,
  })
  public isEdit: boolean;
  
  @Prop({
    default: false,
  })
  public disabled: boolean;

  @Prop({default:true})
  public showQtdeReferencia: boolean

  public materialFormIsEdit: boolean = false;
  public materialFormOpen: boolean = false;
  public materialFormItem: any = {};

  public subgroups: any[] = [];
  public measurementUnits: any = [];

  private getHeaders() {
    let headers = [];
    headers.push({ text: 'Ativo', value: 'insumo.descricao' });
    headers.push({ text: 'Quantidade', value: 'quantidade' });
    if (this.showQtdeReferencia) {
      headers.push({ text: 'Quantidade de referência', value: 'quantidadeReferencia' });
    }
    headers.push({ text: 'Ações', value: 'actions', sortable: false });
    return headers;
  }

  public materialFormOpenHandler(): void {
    this.materialFormIsEdit = false;
    this.materialFormItem = {
      quantidadeReferencia: 1,
    };
    this.materialFormOpen = true;
  }

  public materialFormClose(): void {
    this.materialFormIsEdit = false;
    this.materialFormItem = {};
    this.materialFormOpen = false;
  }

  public materialFormSave(material: any): void {
    const uuidv4 = require('uuid/v4');
    if (!this.materialFormIsEdit) {
      // New Item
      material.id = uuidv4();
      this.data.push(material);
    } else {
      // Edit Item
      const index = this.data.findIndex((i) => i.id === material.id);
      this.$set(this.data, index, material);
    }

    this.materialFormClose();
  }

  public materialEdit(item: any): void {
    this.materialFormIsEdit = true;
    this.materialFormItem = item;
    this.materialFormOpen = true;
  }

  public materialDelete(item: any): void {
    const index = this.data.findIndex((i) => i.insumo.id === item.insumo.id);
    this.data.splice(index, 1);
  }
}
